import { OrganizationType } from './organization-type.enum';

export class OrganizationProjectSection {
  sectionId?: number;
  beamYardSectionTag?: boolean;
  sectionType?: OrganizationType;
  sectionFullCode?: string;
  sectionName?: string;
  refSectionIds?: number[];
  // 前端自用
  stage?: number;
}
